var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYellowSquareRotated = function SvgYellowSquareRotated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.724,
    height: 90.724
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 121",
    width: 64.152,
    height: 64.152,
    rx: 3,
    transform: "rotate(45 22.692 54.756)",
    fill: "rgba(255,222,140,0.2)"
  })));
};
export { SvgYellowSquareRotated as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MC43MjQiIGhlaWdodD0iOTAuNzI0IiB2aWV3Qm94PSIwIDAgOTAuNzI0IDkwLjcyNCI+DQogIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTIxIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxMjEiIHdpZHRoPSI2NC4xNTIiIGhlaWdodD0iNjQuMTUyIiByeD0iMyIgdHJhbnNmb3JtPSJtYXRyaXgoMC43MDcsIDAuNzA3LCAtMC43MDcsIDAuNzA3LCA0NS4zNjEsIDApIiBmaWxsPSJyZ2JhKDI1NSwyMjIsMTQwLDAuMikiLz4NCjwvc3ZnPg0K";